import { type CSSProperties } from 'react';

import { useEligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/hooks/useEligibilityCoupon';
import { Block } from '@/domains/productDiscovery/ProductPage/b2c/components/Block/Block';
import { useProductBundleRecommendations } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/hooks/useRecommendations/useRecommendations';

import styles from './outlineBundle.module.scss';

export const OutlineBundlePlaceholder = () => {
  const mainProductCoupon = useEligibilityCoupon();

  const [, , , skeletons] = useProductBundleRecommendations();

  if (skeletons <= 1) return null;

  return (
    <Block>
      <div
        style={
          {
            '--bundleHasCoupon': mainProductCoupon ? 1 : 0,
            '--bundleItems': skeletons,
            '--withCheckbox': skeletons > 2 ? '52px' : '0px',
          } as CSSProperties
        }
        className={styles.placeholder}
        data-testid="outline-product-bundle-placeholder"
      />
    </Block>
  );
};

OutlineBundlePlaceholder.displayName = 'OutlineBundlePlaceholder';
